export default __webpack_public_path__ + "static/media/icon_postgre_sql.d9c618ff.svg";